// src/components/Buttons.js
import colors from './colors.js';

// Simple Button component
export function Button({ children, variant = 'primary', style = {}, ...props }) {
  // Define background and text color based on variant
  const backgroundColor = colors[variant] || colors.primary;
  const color = colors.font.white;

  const buttonStyle = {
    backgroundColor,
    color,
    borderRadius: 100,
    padding: '12px 24px',
    fontSize: '1.3em',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 3px 5px rgba(0,0,0,0.27)',
    width: '65%',
    height: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    ...style, // Allow overriding styles via props
  };

  return (
    <button style={buttonStyle} {...props}>
      {children}
    </button>
  );
}

// Optional smaller half-width button
export function ButtonHalf({ children, style = {}, ...props }) {
  return (
    <Button
      style={{ width: '35%', height: 50, ...style }}
      {...props}
    >
      {children}
    </Button>
  );
}
